export const DEBOUNCE_THRESHOLD = 500;
export const PAGE_SIZE = 50;
export const DISPLAY_DATE_FORMAT = 'MM/dd/yyyy';
export const DISPLAY_TIME = 'hh:mm a';
export const API_DATE_FORMAT = 'yyyy-MM-dd';
export const CLIENT_PROXY_TOKEN_KEY = "clientProxyToken";
export const TOKEN_KEY = "clientToken";
export const LOGIN_PAYLOAD_KEY = "loginPayload";
export const M_DASH_UNICODE = '\u2014';
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const ENTER_KEY_CODE = 13;
